import React from 'react'
import * as S from '../style'
import { ActionProps, TableHeaderProps } from '../types'

interface TableHead {
  columns: TableHeaderProps[]
  actions: ActionProps[]
  hasExpandable?: boolean
  headerBgColor?: string
}

const Head: React.FC<TableHead> = ({
  columns,
  actions = [],
  hasExpandable,
  headerBgColor,
}) => {
  return (
    <S.StyleHeadWrapper headerBgColor={headerBgColor}>
      <S.StyleTableRow>
        {hasExpandable && <S.StyleHeader />}

        {columns.map((item, i) => (
          <S.StyleHeader key={item.key || i}>{item.title}</S.StyleHeader>
        ))}
        {actions.length > 0 && <S.StyleHeader>Actions</S.StyleHeader>}
      </S.StyleTableRow>
    </S.StyleHeadWrapper>
  )
}

export default Head
